import { combineReducers } from 'redux';
import dataFlowReducer from './data-flow';
import dataTableReducer from './data-table';

export default combineReducers({
  dataFlow: dataFlowReducer,
  dataTable: dataTableReducer
});
